import { discard } from 'owa-locstrings/lib/strings/discard.locstring.json';
import { confirmDialogSaveText } from 'owa-locstrings/lib/strings/confirmdialogsavetext.locstring.json';
import loc from 'owa-localize';
import * as React from 'react';
import { DefaultButton, PrimaryButton } from '@fluentui/react/lib/Button';

import styles from './CustomRecurrenceFooter.scss';

export interface CustomRecurrenceFooter {
    onSave: () => void;
    onDiscard: () => void;
}

const CustomRecurrenceFooter = (props: CustomRecurrenceFooter) => {
    return (
        <div className={styles.footer}>
            <PrimaryButton onClick={props.onSave}>{loc(confirmDialogSaveText)}</PrimaryButton>
            <DefaultButton
                className={styles.discardButton}
                text={loc(discard)}
                onClick={props.onDiscard}
            />
        </div>
    );
};

export default CustomRecurrenceFooter;
